import React, { useEffect, useState } from "react";
import MUIDataTable from "mui-datatables";
import { Box, Chip, CircularProgress } from "@mui/material";
import { IconButton, Tooltip } from "@mui/material";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import { useNavigate } from "react-router-dom";
import { Button } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";

import { getOffers } from "../../apis/cart/apis";

export default function ListingScreen() {
  const navigate = useNavigate();
  const [offers, setOffers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [count, setCount] = useState(0);
  const [searchText, setSearchText] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState("");
  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedSearch(searchText);
      setPage(0);
    }, 1000);

    return () => clearTimeout(timer);
  }, [searchText]);
  useEffect(() => {
    const fetchOffers = async () => {
      try {
        setLoading(true);

        const response = await getOffers(
          page + 1,
          rowsPerPage,
          debouncedSearch,
        );

        setOffers(response.data.results);
        setCount(response.data.count);
      } catch (error) {
        console.log(error);
      } finally {
        setLoading(false);
      }
    };

    fetchOffers();
  }, [page, rowsPerPage, debouncedSearch]);

  const columns = [
    {
      name: "name",
      label: "Offer Name",
      options: {
        filter: false,
      },
    },

    {
      name: "offer_type",
      label: "Offer Type",
      options: {
        filter: false,
      },
    },

    {
      name: "voucher_count",
      label: "Vouchers",
      options: {
        filter: false,
      },
    },

    // {
    //   name: "start_datetime",
    //   label: "Start Date",
    //   options: {
    //     filter: false,
    //     customBodyRender: (value) =>
    //       value
    //         ? new Date(value).toLocaleString([], {
    //             year: "numeric",
    //             month: "short",
    //             day: "numeric",
    //             hour: "2-digit",
    //             minute: "2-digit",
    //           })
    //         : "-",
    //   },
    // },

    // {
    //   name: "end_datetime",
    //   label: "End Date",
    //   options: {
    //     filter: false,
    //     customBodyRender: (value) =>
    //       value
    //         ? new Date(value).toLocaleString([], {
    //             year: "numeric",
    //             month: "short",
    //             day: "numeric",
    //             hour: "2-digit",
    //             minute: "2-digit",
    //           })
    //         : "-",
    //   },
    // },

    {
      name: "priority",
      label: "Priority",
      options: {
        filter: false,
      },
    },

    {
      name: "incentive",
      label: "Incentive",
      options: {
        filter: false,
      },
    },

    {
      name: "condition",
      label: "Condition",
      options: {
        filter: false,
      },
    },

    {
      name: "is_available",
      label: "Available",
      options: {
        filter: false,
        customBodyRender: (value) => (
          <Chip
            label={value ? "Yes" : "No"}
            color={value ? "success" : "error"}
            size="small"
          />
        ),
      },
    },
    // {
    //   name: "restrictions",
    //   label: "Restrictions",
    //   options: {
    //     filter: false,
    //     sort: false,
    //   },
    // },

    {
      name: "num_applications",
      label: "Uses",
      options: {
        filter: false,
      },
    },

    {
      name: "total_discount",
      label: "Cost",
      options: {
        filter: false,
        customBodyRender: (value) => `₹${value}`,
      },
    },
    {
      name: "id",
      label: "Action",
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value) => (
          <Box
            display="flex"
            flexDirection="column"
            alignItems="center"
            gap={0.5}
          >
            <Tooltip title="View">
              <IconButton
                color="primary"
                onClick={() => navigate(`/w86zjruk6q/offers/${value}`)}
              >
                <RemoveRedEyeIcon />
              </IconButton>
            </Tooltip>

            <Tooltip title="Edit">
              <IconButton
                color="primary"
                onClick={() => navigate(`/w86zjruk6q/offers/${value}/edit`)}
              >
                <EditOutlinedIcon />
              </IconButton>
            </Tooltip>
          </Box>
        ),
      },
    },
  ];

  const options = {
    selectableRows: "none",
    responsive: "standard",
    elevation: 0,

    serverSide: true,

    count,

    page,

    rowsPerPage,

    rowsPerPageOptions: [10, 20, 50],

    onTableChange: (action, tableState) => {
      switch (action) {
        case "changePage":
          setPage(tableState.page);
          break;

        case "changeRowsPerPage":
          setRowsPerPage(tableState.rowsPerPage);
          setPage(0);
          break;

        default:
          break;
      }
    },
    onSearchChange: (text) => {
      setSearchText(text || "");
    },

    download: false,
    print: false,
    viewColumns: false,
    filter: false,
    search: true,
    sort: false,
  };
  return (
    <Box
      p={2}
      sx={{
        overflowX: "auto",
        // pr: 10, // right padding
      }}
    >
      <Box display="flex" justifyContent="flex-end" mb={2}>
        <Button
          variant="contained"
          startIcon={<AddIcon />}
          onClick={() => navigate("/w86zjruk6q/offers/create")}
        >
          Create Offer
        </Button>
      </Box>
      {loading && (
        <Box mb={2}>
          <CircularProgress size={20} />
        </Box>
      )}

      <MUIDataTable
        title={"All Offers"}
        data={offers}
        columns={columns}
        options={options}
      />
    </Box>
  );
}
